import 'twin.macro';
import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Dialog from '@teetsh/app/src/components/Dialog';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

interface Props {
  index?: number;
  joyrideProps: TooltipRenderProps;
  size?: number;
}

function getNextLabel(locale: any, isLastStep: boolean) {
  if (locale.forceNext) {
    return locale.forceNext;
  }
  if (isLastStep && locale.next.last) {
    return locale.next.last;
  }
  if (locale.next) {
    return locale.next;
  }
  return 'Suivant';
}

export default function ToolTip(props: Props) {
  const {
    joyrideProps: {
      primaryProps,
      backProps,
      continuous,
      closeProps,
      step,
      index,
      isLastStep,
      tooltipProps,
    },
  } = props;
  const { t } = useTranslation(['common']);

  return (
    <div {...tooltipProps}>
      <div tw="bg-brand-quiet rounded-xl md:mt-10">
        <div tw="p-6">{step.content}</div>
        <Dialog.Footer tw="rounded-b-xl">
          {(step as any).preventFurtherDisplayFct && (
            <Button
              large
              minimal
              onClick={(step as any).preventFurtherDisplayFct}
            >
              {t('common:buttons.dontShowAgain')}
            </Button>
          )}
          {index > 0 && (
            <Button large minimal onClick={backProps.onClick}>
              {step.locale ? step.locale.back : t('common:buttons.back')}
            </Button>
          )}
          {continuous && (
            <Button
              aria-label="Suivant"
              intent="primary"
              onClick={primaryProps.onClick}
            >
              {getNextLabel(step.locale, isLastStep)}
            </Button>
          )}
          {!continuous && (
            <Button
              aria-label="Suivant"
              // Je sais pas pourquoi mais ça marche pas super avec testcafe si on passe pas par une classe pour sélectionner cet élément
              className="test-next"
              intent="primary"
              large
              onClick={closeProps.onClick}
              rightIcon={isLastStep ? null : ArrowRight}
            >
              {getNextLabel(step.locale, isLastStep)}
            </Button>
          )}
        </Dialog.Footer>
      </div>
    </div>
  );
}
